import React, {useEffect, useState} from 'react';

import {DatasetDataApi} from "api/DatasetDataApi";
import {T} from 'services/lang/LanguageService';
import {DatasetDefaultConfig} from "models/dataset-models";
import {ProgressSpinner} from "primereact/progressspinner";
import {DatasetDataInfoResponse} from "../../../api/model/dataset/DatasetDataInfoResponse";
import NonExistantDatasetsPrinting from "../../basic/non-existant-datasets-printing/NonExistantDatasetsPrinting";
import DatasetToggleCard from "./DatasetToggleCard";
import './DatasetToggleTable.scss';
import {IDatasetToggleTableConfigProps} from "./common/api/interfaces/interfaces";

export default function DatasetToggleTable (props: IDatasetToggleTableConfigProps) {

    const [loading, setLoading] = useState<boolean>(true)

    const [datasetData, setDatasetData] = useState<Array<DatasetDataInfoResponse>>([]);
    const [nonExistent, setNonExistent] = useState<Array<string>>([])

    const order = props.datasets.map(obj => obj.identifier);

    useEffect(() => {
        DatasetDataApi.getRecentData(order, {strict: false})
            .then((res) => {
                if (res.data) {
                    if (res.data.length > 0) {
                        setDatasetData(keepQueue(res.data))
                    }
                }
                setLoading(false);
            })
            .catch((err) => {
                console.error(err)
                setLoading(false);
            })
    }, [props.datasets])

    useEffect(() => {
        findUnexistingDatasets()
    }, [datasetData])

    const keepQueue = (data: Array<any>): Array<any> => {
        return order.map(obj => {
            return data.find(e => e.identifier === obj)
        })
    }

    const findUnexistingDatasets = () => {
        const unexistringDatasets:Array<string> = [];
        props.datasets.forEach((conf: DatasetDefaultConfig) => {
            const obj = datasetData.find(ob => ob.identifier === conf.identifier)
            if (!obj) {
                unexistringDatasets.push(conf.identifier)
            }
        })

        setNonExistent(unexistringDatasets)
    }

    if (loading) {
      return (
        <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
          <ProgressSpinner className="middle-class" />
        </div>
      );
    }

    if (!props.datasets || props.datasets.length === 0) {
        return <div className="no-data">{T("message.no-datasets-provided")}</div>
    }

    if (props.datasets && props.datasets.length > 0 && datasetData.length === 0 && !loading) {
        return <div className="no-data-wrapper">
            {nonExistent.length > 0 && <NonExistantDatasetsPrinting datasetsArray={nonExistent}/>}
        </div>
    }

    if (datasetData.length > 0 && !loading) {
      return (
        <div className="main-window">
          {props.datasets.map((conf: DatasetDefaultConfig) => {
            const object = datasetData.find(ob => ob.identifier === conf.identifier);
            if (object) {
              let buttonValue: boolean = false;
              if (object.data && object.data.length > 0) {
                const ats = object.data[0].value ? object.data[0].value : 0;
                if (ats && ats !== 0) {
                  buttonValue = true;
                }
              }
              return (
                <div className="card-class" key={conf.identifier}>
                  <DatasetToggleCard
                    result={object}
                    config={conf}
                    value={buttonValue}
                    truncateTo={props.truncateTo}
                  />
                </div>
              );
            }
            return <div key={conf.identifier} />;
          })}
          {nonExistent.length > 0 && <NonExistantDatasetsPrinting datasetsArray={nonExistent} />}
        </div>
      );
    }
    return <p>{T("word.no-data")}</p>;
};
